import React, { memo } from 'react';
import { css } from 'linaria';
import { DesignRegistrationPanel } from 'common/components';
import {
  KITCHEN_SIGN_UP_HREF,
  KITCHEN_CALCULATOR_HREF,
  KITCHEN_ELEMENT_BLOCK,
} from '../../../kitchen-constants';
import { KITCHEN_PANEL_STRUCTURE } from './kitchen-design-panel-constants';

const kitchenDesignPanelSection = css`
  @media (--from-desktop) {
    min-height: 114px;
  }
`;

type KitchenDesignPanelProps = {
  regionId: string;
  isConsultationFormVisible?: boolean;
  withWhiteBackground?: boolean;
};

export const KitchenDesignPanel: React.FC<KitchenDesignPanelProps> = memo(
  ({ regionId, isConsultationFormVisible = false, withWhiteBackground = false }) => {
    const signUpHref = `${KITCHEN_SIGN_UP_HREF}${regionId}`;

    return (
      <DesignRegistrationPanel
        isConsultationFormVisible={isConsultationFormVisible}
        withWhiteBackground={withWhiteBackground}
        className={kitchenDesignPanelSection}
        isNewAnalytics
        structure={{
          panel: {
            ...KITCHEN_PANEL_STRUCTURE.panel,
            actionBlock: [
              {
                elementBlock: KITCHEN_ELEMENT_BLOCK,
                invert: true,
                label: 'Узнать цену',
                variant: 'pseudo',
                href: KITCHEN_CALCULATOR_HREF,
                target: '_blank',
              },
              {
                elementBlock: KITCHEN_ELEMENT_BLOCK,
                href: signUpHref,
                label: 'Записаться',
                target: '_blank',
                variant: 'accent',
              },
            ],
          },
          mobilePanel: {
            ...KITCHEN_PANEL_STRUCTURE.mobilePanel,
            actionBlock: [
              {
                elementBlock: KITCHEN_ELEMENT_BLOCK,
                href: signUpHref,
                label: 'Записаться',
                target: '_blank',
                variant: 'accent',
              },
              {
                elementBlock: KITCHEN_ELEMENT_BLOCK,
                invert: true,
                label: 'Узнать цену',
                variant: 'pseudo',
                href: KITCHEN_CALCULATOR_HREF,
                target: '_blank',
              },
            ],
          },
        }}
      />
    );
  }
);
